
/*
 * -------------------------------
 *  Creation origin: t3zeroseven extension
 *	@created: 05.04.2017, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 * -------------------------------
 *
 * We override the font switcher
 * to enable rem based scaling on html tag
 * for correct resizing of foundation rem based sizes
 */

var fFontSizeBase = parseFloat(1.0);
var fFontSizeMin = parseFloat(0.9);
var fFontSizeMax = parseFloat(1.9);

function fontSizeSwitcher() {

  fFontSizeCurrent = parseFloat($('#canvas').attr('data-fontsize'));
  if ($.cookie('t3zfontsizer')) {
    fFontSizeCurrent = parseFloat($.cookie('t3zfontsizer'));
  }
  //console.log(fFontSizeCurrent);
  setFontSize(fFontSizeCurrent);

  $('#fontsize-minus').click(function (event) {
    event.preventDefault();
    if (fFontSizeCurrent.toFixed(1) > fFontSizeMin.toFixed(1)) {
      fFontSizeCurrent = fFontSizeCurrent - parseFloat(0.1);
    }
    setFontSize(fFontSizeCurrent);
  });

  $('#fontsize-base').click(function (event) {
    event.preventDefault();
    fFontSizeCurrent = fFontSizeBase;
    setFontSize(fFontSizeCurrent);
  });

  $('#fontsize-plus').click(function (event) {
    event.preventDefault();
    if (fFontSizeCurrent.toFixed(1) < fFontSizeMax.toFixed(1)) {
      fFontSizeCurrent = fFontSizeCurrent + parseFloat(0.1);
    }
    setFontSize(fFontSizeCurrent);
  });
}

function setFontSize(fSetFontSize) {
  //console.log(fSetFontSize);
  $.cookie('t3zfontsizer', fSetFontSize, {expires: 1, path: '/'});
  var sSetFontSize = String(fSetFontSize.toFixed(1));
  //console.log(sSetFontSize);
  $('html').attr('data-fontsize', sSetFontSize);
  $('html').css('font-size', sSetFontSize + 'rem');

  $('label.fontsize').removeClass('disabled');

  if (fFontSizeCurrent.toFixed(1) == fFontSizeBase.toFixed(1)) {
    $('#fontsize-base').addClass('disabled');
  }
  if (fFontSizeCurrent.toFixed(1) == fFontSizeMin.toFixed(1)) {
    $('#fontsize-minus').addClass('disabled');
  }
  if (fFontSizeCurrent.toFixed(1) == fFontSizeMax.toFixed(1)) {
    $('#fontsize-plus').addClass('disabled');
  }

  // Update slick slider sizes
  $('.js-slider').slick('setPosition');
}

$(function () {
  fontSizeSwitcher();
});



// WEBPACK FOOTER //
// ./src/js/modules/font-switcher.js